/**
 * API設定管理
 * 段階的移行用の環境変数を一括管理
 */

export interface ApiConfig {
  useLightApi: boolean;
  usePagination: boolean;
  useLazyLoading: boolean;
  defaultPageSize: number;
  apiTimeout: number;
}

/**
 * 環境変数から API設定を取得
 */
export const getApiConfig = (): ApiConfig => {
  return {
    // 軽量版API使用フラグ
    useLightApi: process.env.REACT_APP_USE_LIGHT_API === 'true',
    
    // ページネーション使用フラグ
    usePagination: process.env.REACT_APP_USE_PAGINATION === 'true',
    
    // 遅延ローディング使用フラグ
    useLazyLoading: process.env.REACT_APP_USE_LAZY_LOADING === 'true',
    
    // デフォルトページサイズ
    defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || '16', 10),
    
    // APIタイムアウト（ミリ秒）
    apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  };
};

/**
 * 段階移行用デバッグ情報出力
 */
export const logApiConfig = () => {
  const config = getApiConfig();
  console.log('[ApiConfig] Current API configuration:', config);
  
  if (config.useLightApi) {
    console.log('[ApiConfig] 🚀 Using lightweight API (fetchAllImagesLight)');
  } else {
    console.log('[ApiConfig] 📦 Using legacy API (fetchAllImages)');
  }
  
  if (config.usePagination) {
    console.log(`[ApiConfig] 📄 Pagination enabled (page size: ${config.defaultPageSize})`);
  }
  
  if (config.useLazyLoading) {
    console.log('[ApiConfig] ⚡ Lazy loading enabled');
  }
};

// 開発環境でのみ設定をログ出力
if (process.env.NODE_ENV === 'development') {
  logApiConfig();
}